import { render, staticRenderFns } from "./personInfo.vue?vue&type=template&id=5732a532&scoped=true&"
import script from "./personInfo.vue?vue&type=script&lang=js&"
export * from "./personInfo.vue?vue&type=script&lang=js&"
import style0 from "./personInfo.vue?vue&type=style&index=0&id=5732a532&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5732a532",
  null
  
)

export default component.exports